export const TOUR_SHELL_TABS = ["task", "caller", "search", "help", "chat"] as const;
export type TourShellTab = (typeof TOUR_SHELL_TABS)[number];

export const TOUR_FOCUSES = [
  "tabs",
  "individual",
  "group",
  "caller",
  "search",
  "clock",
  "overview",
] as const;
export type TourFocus = (typeof TOUR_FOCUSES)[number];

export const TOUR_SIDES = ["top", "right", "bottom", "left"] as const;
export type TourSide = (typeof TOUR_SIDES)[number];

export type TourAnchorKey =
  | "cc-overview"
  | "cc-shell-tabs"
  | "cc-goal"
  | "cc-next-task"
  | "cc-track"
  | "cc-leave-early"
  | "cc-send-chat"
  | "cc-event-title"
  | "cc-event-schedule"
  | "cc-event-amount"
  | "cc-event-location"
  | "cc-event-description"
  | "cc-event-partner"
  | "cc-relevant-volunteers"
  | "cc-add-participants"
  | "cc-participants"
  | "cc-caller-phone"
  | "cc-caller-assign"
  | "cc-search-panel"
  | "cc-search-filters"
  | "cc-search-table"
  | "cc-help"
  | "cc-help-faq"
  | "cc-chat-btn"
  | "cc-chat-compose"
  | "cc-distress"
  | "cc-end-shift"
  | "cc-shift-clock";

export type TourAnchorDef = {
  key: TourAnchorKey;
  label: string;
  element: string | null;
  shellTab: TourShellTab;
  focus: TourFocus;
};

export const TOUR_ANCHORS: TourAnchorDef[] = [
  {
    key: "cc-overview",
    label: "הסבר כללי (בלי הדגשה)",
    element: null,
    shellTab: "task",
    focus: "overview",
  },
  {
    key: "cc-shell-tabs",
    label: "תור, בשיחה, חיפוש",
    element: "[data-tour='cc-shell-tabs']",
    shellTab: "task",
    focus: "tabs",
  },
  {
    key: "cc-goal",
    label: "יעד יומי",
    element: "[data-tour='cc-goal']",
    shellTab: "task",
    focus: "overview",
  },
  {
    key: "cc-next-task",
    label: "משימה הבאה",
    element: "[data-tour='cc-next-task']",
    shellTab: "task",
    focus: "overview",
  },
  {
    key: "cc-track",
    label: "פרטני או קבוצה",
    element: "[data-tour='cc-track']",
    shellTab: "task",
    focus: "overview",
  },
  {
    key: "cc-leave-early",
    label: "בקשה לעבור מוקדם",
    element: "[data-tour='cc-leave-early']",
    shellTab: "task",
    focus: "overview",
  },
  {
    key: "cc-send-chat",
    label: "שליחת משימה לצ'אט",
    element: "[data-tour='cc-send-chat']",
    shellTab: "task",
    focus: "overview",
  },
  {
    key: "cc-event-title",
    label: "כותרת כרטיס המשימה",
    element: "[data-tour='cc-event-title']",
    shellTab: "task",
    focus: "overview",
  },
  {
    key: "cc-event-schedule",
    label: "מועד וסוג ההתנדבות",
    element: "[data-tour='cc-event-schedule']",
    shellTab: "task",
    focus: "overview",
  },
  {
    key: "cc-event-amount",
    label: "כמות משתתפים רצויה",
    element: "[data-tour='cc-event-amount']",
    shellTab: "task",
    focus: "overview",
  },
  {
    key: "cc-event-location",
    label: "מיקום ההתנדבות",
    element: "[data-tour='cc-event-location']",
    shellTab: "task",
    focus: "overview",
  },
  {
    key: "cc-event-description",
    label: "פרטי ההתנדבות",
    element: "[data-tour='cc-event-description']",
    shellTab: "task",
    focus: "overview",
  },
  {
    key: "cc-event-partner",
    label: "העמותה האחראית",
    element: "[data-tour='cc-event-partner']",
    shellTab: "task",
    focus: "overview",
  },
  {
    key: "cc-relevant-volunteers",
    label: "מתנדבים רלוונטיים",
    element: "[data-tour='cc-relevant-volunteers']",
    shellTab: "task",
    focus: "individual",
  },
  {
    key: "cc-add-participants",
    label: "הוספת משתתפים",
    element: "[data-tour='cc-add-participants']",
    shellTab: "task",
    focus: "group",
  },
  {
    key: "cc-participants",
    label: "טבלת הוספת קבוצות",
    element: "[data-tour='cc-participants']",
    shellTab: "task",
    focus: "group",
  },
  {
    key: "cc-caller-phone",
    label: "טלפון בשיחה",
    element: "[data-tour='cc-caller-phone']",
    shellTab: "caller",
    focus: "caller",
  },
  {
    key: "cc-caller-assign",
    label: "שיבוץ בשיחה",
    element: "[data-tour='cc-caller-assign']",
    shellTab: "caller",
    focus: "caller",
  },
  {
    key: "cc-search-panel",
    label: "מסך החיפוש",
    element: "[data-tour='cc-search-panel']",
    shellTab: "search",
    focus: "search",
  },
  {
    key: "cc-search-filters",
    label: "סינוני החיפוש",
    element: "[data-tour='cc-search-filters']",
    shellTab: "search",
    focus: "search",
  },
  {
    key: "cc-search-table",
    label: "טבלת המשימות",
    element: "[data-tour='cc-search-table']",
    shellTab: "search",
    focus: "search",
  },
  {
    key: "cc-help",
    label: "כפתור עזרה",
    element: "[data-tour='cc-help']",
    shellTab: "task",
    focus: "overview",
  },
  {
    key: "cc-help-faq",
    label: "שאלות נפוצות",
    element: "[data-tour='cc-help-faq']",
    shellTab: "help",
    focus: "overview",
  },
  {
    key: "cc-chat-btn",
    label: "כפתור צ'אט",
    element: "[data-tour='cc-chat-btn']",
    shellTab: "task",
    focus: "overview",
  },
  {
    key: "cc-chat-compose",
    label: "כתיבה בצ'אט",
    element: "[data-tour='cc-chat-compose']",
    shellTab: "chat",
    focus: "overview",
  },
  {
    key: "cc-distress",
    label: "מצוקה",
    element: "[data-tour='cc-distress']",
    shellTab: "task",
    focus: "overview",
  },
  {
    key: "cc-end-shift",
    label: "יציאה ממשמרת",
    element: "[data-tour='cc-end-shift']",
    shellTab: "task",
    focus: "overview",
  },
  {
    key: "cc-shift-clock",
    label: "שעון סיום המשמרת",
    element: "[data-tour='cc-shift-clock']",
    shellTab: "task",
    focus: "clock",
  },
];

export type DefaultTourStep = {
  anchorKey: TourAnchorKey;
  kicker: string;
  title: string;
  description: string;
  side: TourSide;
};

export const DEFAULT_CALL_CENTER_TOUR: DefaultTourStep[] = [
  {
    anchorKey: "cc-overview",
    kicker: "המערכת",
    title: "מה עושים במוקד",
    description:
      "במשמרת מקבלים משימות מהתור, מוצאים מתנדב או קבוצה, ומשבצים אותם בכרטיס המשימה. היעד היומי נספר לפי שיבוצים שבוצעו.",
    side: "bottom",
  },
  {
    anchorKey: "cc-shell-tabs",
    kicker: "שלושה מצבים",
    title: "תור, בשיחה, חיפוש",
    description:
      "תור: המשימה שהמערכת נתנה עכשיו. בשיחה: מי שכבר על הקו. חיפוש: כל משימות הארגון, ואפשר לפתוח כל אחת לכרטיס.",
    side: "bottom",
  },
  {
    anchorKey: "cc-goal",
    kicker: "משמרת",
    title: "יעד השיבוצים",
    description:
      "כמה שיבוצים כבר נעשו היום מול היעד. היעד נקבע לרכזת, והמונה עולה אחרי שיבוץ מוצלח.",
    side: "bottom",
  },
  {
    anchorKey: "cc-next-task",
    kicker: "תור",
    title: "מתי עוברים הלאה",
    description:
      "אחרי זמן מינימום על המשימה הכפתור נפתח. עד אז נשארים על הכרטיס ומנסים לשבץ.",
    side: "bottom",
  },
  {
    anchorKey: "cc-track",
    kicker: "תור",
    title: "פרטני או קבוצה",
    description:
      "התג מציין את סוג המשימה. פרטני: מתנדב אחד. קבוצה: שיבוץ דרך הוספת משתתפים, בלשונית הוספת קבוצות.",
    side: "bottom",
  },
  {
    anchorKey: "cc-leave-early",
    kicker: "תור",
    title: "לעבור לפני הזמן",
    description:
      "אם אי אפשר להמשיך על המשימה, שולחים בקשה עם סיבה. הרכזת רואה אותה ויכולה לאשר מעבר.",
    side: "bottom",
  },
  {
    anchorKey: "cc-send-chat",
    kicker: "תור",
    title: "לשתף את המשימה",
    description:
      "שולח את כרטיס המשימה לצ'אט עם הרכזת, כשצריך עזרה בפרטים או בשיבוץ.",
    side: "bottom",
  },
  {
    anchorKey: "cc-event-title",
    kicker: "תור · משימה",
    title: "כרטיס המשימה",
    description:
      "זה אותו כרטיס כמו בטבלת המשימות. הפרטים, הסרגל והטבלאות זהים.",
    side: "bottom",
  },
  {
    anchorKey: "cc-event-schedule",
    kicker: "תור · משימה",
    title: "מתי, וקבועה או חד-פעמית",
    description:
      "המועד מופיע כאן, ומתחתיו כתוב אם זו התנדבות ארוכת טווח או חד-פעמית. את זה אומרים למתנדב לפני השיבוץ.",
    side: "bottom",
  },
  {
    anchorKey: "cc-event-amount",
    kicker: "תור · משימה",
    title: "כמה משתתפים צריך",
    description:
      "המספר הראשון הוא כמה כבר רשומים, והשני הוא הכמות הרצויה. כשהיחס מלא, אין טעם להמשיך לגייס.",
    side: "bottom",
  },
  {
    anchorKey: "cc-event-location",
    kicker: "תור · משימה",
    title: "איפה ההתנדבות",
    description:
      "המיקום שאומרים למתנדב בשיחה.",
    side: "bottom",
  },
  {
    anchorKey: "cc-event-description",
    kicker: "תור · משימה",
    title: "פרטי ההתנדבות",
    description:
      "התיאור המלא: מה עושים, למי, ומה חשוב לדעת לפני השיחה.",
    side: "left",
  },
  {
    anchorKey: "cc-event-partner",
    kicker: "תור · משימה",
    title: "העמותה האחראית",
    description:
      "כשיש ארגון שותף, השם שלו מופיע כאן. לחיצה פותחת את הפרטים: תיאור, ואם העמותה קולטת קבוצות.",
    side: "bottom",
  },
  {
    anchorKey: "cc-relevant-volunteers",
    kicker: "תור · בודד",
    title: "מתנדבים רלוונטיים",
    description:
      "מסננים בטבלה לפי אזור והתאמה, מסמנים מתנדב, ולוחצים הוספה למשימה.",
    side: "top",
  },
  {
    anchorKey: "cc-add-participants",
    kicker: "תור · קבוצה",
    title: "הוספת משתתפים",
    description:
      "שיבוץ קבוצה נעשה כאן, בכרטיס המשימה, לא ממסך נפרד.",
    side: "left",
  },
  {
    anchorKey: "cc-participants",
    kicker: "תור · קבוצה",
    title: "הוספת קבוצות",
    description:
      "בוחרים הוספת קבוצות, מסמנים קבוצה בטבלה, ולוחצים הוספה למשימה. כל המשתתפים נרשמים יחד.",
    side: "top",
  },
  {
    anchorKey: "cc-caller-phone",
    kicker: "בשיחה",
    title: "מי שכבר על הקו",
    description:
      "מזינים טלפון. אם זה מתנדב, מופיעות משימות שאפשר לשבץ לו. אם המספר לא קיים, אפשר לשלוח קישור כללי.",
    side: "bottom",
  },
  {
    anchorKey: "cc-caller-assign",
    kicker: "בשיחה · בודד",
    title: "שיבוץ מי שנמצא בשיחה",
    description:
      "על התנדבות פרטנית לוחצים שבץ. קבוצה משובצת מכרטיס המשימה, בהוספת משתתפים.",
    side: "top",
  },
  {
    anchorKey: "cc-search-panel",
    kicker: "חיפוש",
    title: "למה נכנסים לחיפוש",
    description:
      "כשהתור לא מתאים, או שמישהו מבקש משימה מסוימת, פותחים כאן את כל משימות הארגון.",
    side: "bottom",
  },
  {
    anchorKey: "cc-search-filters",
    kicker: "חיפוש",
    title: "סינון הטבלה",
    description:
      "מסננים לפי אזור, מסלול, סטטוס ותאריך. כך מוצאים משימה פתוחה בלי לעבור על כל הרשימה.",
    side: "bottom",
  },
  {
    anchorKey: "cc-search-table",
    kicker: "חיפוש",
    title: "פתיחת כרטיס מהטבלה",
    description:
      "לחיצה על שורה פותחת את אותו כרטיס משימה. משם מוסיפים מתנדב רלוונטי או קבוצה בהוספת משתתפים.",
    side: "top",
  },
  {
    anchorKey: "cc-help",
    kicker: "עזרה",
    title: "עזרה וסיור חוזר",
    description:
      "מכאן פותחים שוב את הסיור, וגם את השאלות הנפוצות שהרכזת מעדכנת.",
    side: "bottom",
  },
  {
    anchorKey: "cc-help-faq",
    kicker: "עזרה",
    title: "שאלות נפוצות",
    description:
      "תשובות קצרות לשאלות שחוזרות במשמרת. הרכזת עורכת אותן משולחן הניהול.",
    side: "top",
  },
  {
    anchorKey: "cc-chat-btn",
    kicker: "צ'אט",
    title: "צ'אט עם הרכזת",
    description:
      "הודעות בזמן אמת. משתמשים בזה כשצריך אישור, הבהרה, או כששלחתם משימה מהכרטיס.",
    side: "bottom",
  },
  {
    anchorKey: "cc-chat-compose",
    kicker: "צ'אט",
    title: "כתיבת הודעה",
    description:
      "כותבים כאן לרכזת. ההודעה נשארת במשמרת והרכזת רואה אותה בעמדות הפעילות.",
    side: "top",
  },
  {
    anchorKey: "cc-distress",
    kicker: "משמרת",
    title: "מצוקה",
    description:
      "למקרה חריג בשיחה. נשלחת התראה מיידית לרכזת, בלי לחכות לתור.",
    side: "bottom",
  },
  {
    anchorKey: "cc-end-shift",
    kicker: "משמרת",
    title: "יציאה",
    description:
      "סוגר את המשמרת. אפשר להשאיר משוב קצר לרכזת לפני היציאה.",
    side: "bottom",
  },
  {
    anchorKey: "cc-shift-clock",
    kicker: "משמרת",
    title: "שעת הסיום",
    description:
      "לחיצה על השעון משנה את שעת סיום המשמרת. עד 8 שעות מההתחלה.",
    side: "bottom",
  },
];

/** שלבי פרטי המשימה שנוספו אחרי שהסיור כבר אותחל בארגונים קיימים. */
export const MISSION_DETAIL_TOUR_ANCHORS = [
  "cc-event-schedule",
  "cc-event-amount",
  "cc-event-location",
  "cc-event-description",
  "cc-event-partner",
] as const satisfies readonly TourAnchorKey[];

export function tourAnchorByKey(key: string): TourAnchorDef | undefined {
  return TOUR_ANCHORS.find((anchor) => anchor.key === key);
}
